import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-afastamento-setor',
  templateUrl: './afastamento-setor.component.html',
  styleUrls: ['./afastamento-setor.component.scss']
})
export class AfastamentoSetorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
